import { createContext, useContext } from 'react'

export const ErrorContext = createContext({})
export const UseErrorContext = () => useContext(ErrorContext)